module.exports = __webpack_public_path__ + "static/media/content-04-m.b4306c53.png";